import api from "PFCore/api";
import { Id } from "PFCore/types";
import { KPIResult } from "PFCore/types/kpi";

export const fetchKPIResults = async (engagementId: Id) =>
  api<KPIResult[]>({ url: `/engagements/${engagementId}/kpi_results` });
